import { render, staticRenderFns } from "./person-profile.vue?vue&type=template&id=f91cc35e"
import script from "./person-profile.vue?vue&type=script&lang=js"
export * from "./person-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports